import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
import App from "./App";
import { BrowserRouter as Router } from "react-router-dom";
import { HashRouter } from 'react-router-dom'
import reportWebVitals from "./reportWebVitals";
import { ChakraProvider, extendTheme, ColorModeProvider } from "@chakra-ui/react";

const config = {
  initialColorMode: 'dark',
  useSystemColorMode: false,
};

const theme = extendTheme({ config });
ReactDOM.render(
  <HashRouter>
    <ChakraProvider theme={theme}>
      <App />
    </ChakraProvider>
  </HashRouter>,
  document.getElementById("root")
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
